// Admin - Dashbaord.

import React from 'react';
import Config from '../../lib/Config';
import Header from '../../lib-ui/admin/Header';
import UIString from '../../assets/content/UIString';
import { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Button } from '@mui/material';
import axios from 'axios';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavBar from '../../lib-ui/admin/NavBar';
import Alert from '@mui/material/Alert';
import Util from '../../lib/Util';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// import { useNavigate } from 'react-router-dom';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import Chip from '@mui/material/Chip';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import Block1Icon from '@mui/icons-material/Block';
import IOSSwitch from '../../lib-ui/common/IOSSwitch';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
//import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import Pagination from '@mui/material/Pagination';
import PagePanel from '../../lib-ui/common/PagePanel';
import SearchBar from '../../lib-ui/admin/SearchBar';
import { useSearchParams, useParams } from 'react-router-dom';
import '../../assets/style/common.css';
import '../../assets/style/admin.css';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import '../../assets/style/admin.css';
import Divider from '@mui/material/Divider';
import SectionNavButton from '../../lib-ui/common/SectionNavButton';




const lang = Util.get_lang();

export default () => {

    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [navTitle, setNavTitle] = useState('');
    const [flagContent, setFlagContent] = useState('');
    const [flagToast, setFlagToast] = useState(false);
    const [toastMsg, setToastMsg] = useState();
    const [toastModeIcon, setToastModeIcon] = useState();
    const closeToast = () => { flagToast ? setFlagToast(false) : setFlagToast(true); }
    const showToast = (mode, msg) => {
        switch (mode) {
            case 'info': setToastModeIcon(<InfoIcon sx={{ fontSize: '32px', color: '#66ff66' }} />); break;
            case 'warning': setToastModeIcon(<WarningIcon sx={{ fontSize: '18px', color: '#6666ff' }} />); break;
            case 'error': setToastModeIcon(<WarningIcon sx={{ fontSize: '32px', color: '#a0a0a0' }} />); break;
        }

        setToastMsg(msg);
        setFlagToast(true);
    }

    const [detail, setDetail] = useState({});
    const [noticeForm, setNoticeForm] = useState({
        languages: [],
        targets: [],
        channels: []
    });

    const [target, settarget] = useState();
    const [title, setTitle] = useState();
    const [content, setContent] = useState();
    const [noticeLanguage, setNoticeLanguage] = useState('');
    const [noticeTarget, setNoticeTarget] = useState('');
    const [noticeChannel, setNoticeChannel] = useState('');
    const [noticeFile, setNoticeFile] = useState(null);


    const [lightbox, setLightbox] = useState(false);
    const [lightboxImages, setLightboxImages] = useState([]);



    useEffect(() => {

        setNavTitle([UIString[lang]['NAV_NOTICE_CREATE']]);
        load_form();
        // load_detail();

    }, []);


    function load_form() {

        // Get data.
        Util.get(
            Util.api_url(lang, '/admin/notice/form'),
            (data) => {

                setNoticeForm({
                    languages: data.languages,
                    targets: data.targets,
                    channels: data.channels
                });

            },
            (err) => {

                if (err.error_code == 'LOGIN_REQUIRED') {
                    alert(err.error);
                    document.location = Util.page_url(lang, '/');
                } else {
                    showToast(err.error);
                }
            }
        );
    }



    const load_page = (t) => {
        window.location.href = '';// Config.BASE_URL + '/admin/corp/list/' + t;
    }





    function load_detail() {

        // Get data.
        Util.get(
            Util.api_url(lang, '/admin/notice/detail/' + params.id),
            (data) => {
                setDetail(data);
            },
            (err) => {

                if (err.error_code == 'LOGIN_REQUIRED') {
                    alert(err.error);
                    document.location = Util.page_url(lang, '/');
                } else {
                    showToast(err.error);
                }
            }
        );
    }



    const set_notice_file = (e) => {
        setNoticeFile(e.target.files[0]);
    }

    function activate(id) {
        let form = new FormData();

        form.col = 'status';
        form.value = 'ACTIVE';

        Util.post(
            Util.api_url(lang, '/admin/notice/update/' + params.id),
            { name: 'status', value: 'ACTIVE' },
            (data) => {
                //setDetail(data);
                load_detail(params.id);
            },
            (err) => {

                if (err.error_code == 'LOGIN_REQUIRED') {
                    alert(err.error);
                    document.location = Util.page_url(lang, '/');
                } else {
                    showToast(err.error);
                }
            }
        );
    }



    function inactivate(id) {

        let form = new FormData();
        form.col = 'status';
        form.value = 'INACTIVE';

        Util.post(
            Util.api_url(lang, '/admin/notice/update/' + params.id),
            { name: 'status', value: 'INACTIVE' },
            (data) => {
                //setDetail(data);
                load_detail(params.id);
            },
            (err) => {

                if (err.error_code == 'LOGIN_REQUIRED') {
                    alert(err.error);
                    document.location = Util.page_url(lang, '/');
                } else {
                    showToast(err.error);
                }
            }
        );
    }


    function signout(id) {

    }


    function delete_corp(id) {
        let form = new FormData();

        Util.post(
            Util.api_url(lang, '/admin/corp/delete/' + params.id),
            form,
            (data) => {
                //setDetail(data);
                load_detail(params.id);
            },
            (err) => {

                if (err.error_code == 'LOGIN_REQUIRED') {
                    alert(err.error);
                    document.location = Util.page_url(lang, '/');
                } else {
                    showToast(err.error);
                }
            }
        );
    }






    function show_reg_image(img) {

        setLightboxImages([img]);
        setLightbox(true);

    }

    function show_reg_pdf(pdf_file) {

        const t = new Date().getTime();
        window.open(pdf_file);

    }


    function submit_form() {
        /*
        if (String(noticeLanguage).trim() == '') { showToast('error', 'PLease select language.'); return; }
        if (String(noticeTarget).trim() == '') { showToast('error', 'PLease select target.'); return; }
        //if (String(content).trim() == '') { showToast('error', 'PLease input content.'); return; }
        if (String(title).trim() == '') { showToast('error', 'PLease input title.'); return; }
        if (String(content).trim() == '') { showToast('error', 'PLease input content.'); return; }

    let form = new FormData();
    form.append('language',noticeLanguage);
    form.append('target',noticeTarget);
    form.append('channel',noticeChannel);
    form.append('title',title);
    form.append('content',content);
    if( noticeFile != null ){form.append('image',noticeFile);}
console.log(form);
    axios.post(Util.api_url(lang, '/admin/notice/create'), form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },

      })
      .then((response) => {
        console.log("File uploaded successfully:", response.data);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  */

        if (String(noticeLanguage).trim() == '') { showToast('error', 'PLease select language.'); return; }
        if (String(noticeTarget).trim() == '') { showToast('error', 'PLease select target.'); return; }
        //if (String(content).trim() == '') { showToast('error', 'PLease input content.'); return; }
        if (String(title).trim() == '') { showToast('error', 'PLease input title.'); return; }
        if (String(content).trim() == '') { showToast('error', 'PLease input content.'); return; }


        const form = new FormData();
        /*
        form.append('language','ko');
        form.append('target','USER');
        form.append('channel','app-user');
        form.append('title','test title');
        form.append('content','test content');
        */
        form.append('language', noticeLanguage);
        form.append('target', noticeTarget);
        form.append('channel', noticeChannel);
        form.append('title', title);
        form.append('content', content);
        if (noticeFile != null) { form.append('notice_image', noticeFile); }
        //console.log(form);
        axios.post(Util.api_url(lang, '/admin/notice/create'), form, {
            headers: {
                "Content-Type": "multipart/form-data",
            },

        })
            .then((response) => {
                console.log("File uploaded successfully:", response.data);
            })
            .catch((error) => {
                console.error("Error uploading file:", error);
            });
        return;
    }
    /*Util.post_form(
        Util.api_url(lang, '/admin/notice/create'),
        form,
        (data) => {
            //setDetail(data);
            //load_detail(params.id);
            alert("created");
        },
        (err) => {

            if (err.error_code == 'LOGIN_REQUIRED') {
                alert(err.error);
                document.location = Util.page_url(lang, '/');
            } else {
                showToast(err.error);
            }
        }
    );
}
*/

    return (
        <>
            <Header code={'notice'} />
            <div style={{ width: '1000px', height: '100%', minHeight: '600px', paddingTop: '60px', textAlign: 'center', backgroundColor: '#ffffff', margin: '0px auto' }}>

                <Stack className='page_title' direction={'col'}>
                    <NavBar text={navTitle} key={navTitle} />
                    {/*<span className='nav_right_button' style={{ whiteSpace: 'nowrap' }} onClick={() => { window.history.back() }}>{UIString[lang]['EDIT']}</span>*/}
                </Stack>


                <Paper elevation={0} sx={{ padding: '2px', textAlign: 'left', fontSize: '13px', marginBottom: '38px', display: `${flagContent}` }}>

                    <table style={{ width: '100%', bordeR: 'none', fontSize: '13px' }}>

                        <tr>
                            <td className='detail_label_td' style={{ width: '80px', height: '48px' }}>Language</td>
                            <td className='detail_data_td'>
                                <Select
                                    variant="outlined"
                                    sx={{
                                        width: '280px',
                                        paddingTop: '2px',
                                        backgroundColor: '#transparent', // Grey background
                                        height: '40px',             // Fixed height
                                        borderRadius: 1,            // Optional: slightly rounded corners
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',           // No border
                                        },
                                        '& .MuiSelect-select': {
                                            paddingLeft: '12px',      // Padding similar to TextField
                                            fontSize: '12px',         // Font size for placeholder text
                                        },
                                        '& .MuiSelect-icon': {
                                            color: '#757575',         // Color for dropdown arrow
                                        },

                                        '& .MuiMenuItem-root.Mui-selected': {
                                            backgroundColor: '#ffffff', // Background color when an item is selected
                                        },
                                        '& .MuiMenuItem-root:hover': {
                                            backgroundColor: '#f1f1f1', // Hover state color
                                        },

                                        '& .MuiMenuItem-root.Mui-selected': {
                                            backgroundColor: '#ffffff', // Change the background color of selected item
                                        },
                                        '& .MuiMenuItem-root:hover': {
                                            backgroundColor: '#00ff00', // Optional: hover effect for items
                                        },

                                        //'& .MuiSelect-select': {
                                        //  color: 'red', // Text color of the selected item
                                        //  backgroundColor: '#00ff00', // Background color of the selected item
                                        //    },
                                        //  '& .MuiOutlinedInput-notchedOutline': {
                                        //    borderColor: 'green', // Border color of the select box
                                        //  },
                                        //   '& .MuiSelect-icon': {
                                        //     color: 'blue', // Color of the dropdown arrow
                                        //   },

                                    }}
                                    /*renderValue={(selected) => (selected ? selected : <span style={{ color: '#2e2e2e' }}>{UIString[lang]['ADMIN_PROFILE_DESC']}</span>)}*/
                                    onChange={(t) => { setNoticeLanguage(t.target.value) }}
                                    value={noticeLanguage}
                                    MenuProps={{
                                        sx: {

                                            '& .MuiPaper-root': {
                                                width: '200px',
                                                marginTop: '8px', // Moves the dropdown menu down by 10px
                                                marginRight: '-28px',
                                            },
                                        },
                                    }}
                                >
                                    {noticeForm.languages.map((item, map) => <MenuItem value={item.value} sx={{ fontSize: '13px', height: '22px', marginTop: '8px' }} >{item.label}</MenuItem>)}
                                </Select>
                            </td>
                        </tr>
                        <tr>
                            <td className='detail_label_td' style={{ height: '48px' }}>Target</td>
                            <td className='detail_data_td'>
                                <Select
                                    variant="outlined"
                                    sx={{
                                        width: '280px',
                                        paddingTop: '2px',
                                        backgroundColor: '#transparent', // Grey background
                                        height: '40px',             // Fixed height
                                        borderRadius: 1,            // Optional: slightly rounded corners
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',           // No border
                                        },
                                        '& .MuiSelect-select': {
                                            paddingLeft: '12px',      // Padding similar to TextField
                                            fontSize: '12px',         // Font size for placeholder text
                                        },
                                        '& .MuiSelect-icon': {
                                            color: '#757575',         // Color for dropdown arrow
                                        },

                                        '& .MuiMenuItem-root.Mui-selected': {
                                            backgroundColor: '#ffffff', // Background color when an item is selected
                                        },
                                        '& .MuiMenuItem-root:hover': {
                                            backgroundColor: '#f1f1f1', // Hover state color
                                        },

                                        '& .MuiMenuItem-root.Mui-selected': {
                                            backgroundColor: '#ffffff', // Change the background color of selected item
                                        },
                                        '& .MuiMenuItem-root:hover': {
                                            backgroundColor: '#00ff00', // Optional: hover effect for items
                                        },

                                        //'& .MuiSelect-select': {
                                        //  color: 'red', // Text color of the selected item
                                        //  backgroundColor: '#00ff00', // Background color of the selected item
                                        //    },
                                        //  '& .MuiOutlinedInput-notchedOutline': {
                                        //    borderColor: 'green', // Border color of the select box
                                        //  },
                                        //   '& .MuiSelect-icon': {
                                        //     color: 'blue', // Color of the dropdown arrow
                                        //   },

                                    }}
                                    /*renderValue={(selected) => (selected ? selected : <span style={{ color: '#2e2e2e' }}>{UIString[lang]['ADMIN_PROFILE_DESC']}</span>)}*/
                                    onChange={(t) => { setNoticeTarget(t.target.value) }}
                                    value={noticeTarget}
                                    MenuProps={{
                                        sx: {

                                            '& .MuiPaper-root': {
                                                width: '200px',
                                                marginTop: '8px', // Moves the dropdown menu down by 10px
                                                marginRight: '-28px',
                                            },
                                        },
                                    }}
                                >
                                    {noticeForm.targets.map((item, map) => <MenuItem value={item.value} sx={{ fontSize: '13px', height: '22px', marginTop: '8px' }} >{item.label}</MenuItem>)}
                                </Select>

                            </td>
                        </tr>
                        <tr>
                            <td className='detail_label_td' style={{ height: '48px' }}>Channel</td>
                            <td className='detail_data_td'>
                                <Select
                                    variant="outlined"
                                    sx={{
                                        width: '280px',
                                        paddingTop: '2px',
                                        backgroundColor: '#transparent', // Grey background
                                        height: '40px',             // Fixed height
                                        borderRadius: 1,            // Optional: slightly rounded corners
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',           // No border
                                        },
                                        '& .MuiSelect-select': {
                                            paddingLeft: '12px',      // Padding similar to TextField
                                            fontSize: '12px',         // Font size for placeholder text
                                        },
                                        '& .MuiSelect-icon': {
                                            color: '#757575',         // Color for dropdown arrow
                                        },

                                        '& .MuiMenuItem-root.Mui-selected': {
                                            backgroundColor: '#ffffff', // Background color when an item is selected
                                        },
                                        '& .MuiMenuItem-root:hover': {
                                            backgroundColor: '#f1f1f1', // Hover state color
                                        },

                                        '& .MuiMenuItem-root.Mui-selected': {
                                            backgroundColor: '#ffffff', // Change the background color of selected item
                                        },
                                        '& .MuiMenuItem-root:hover': {
                                            backgroundColor: '#00ff00', // Optional: hover effect for items
                                        },

                                        //'& .MuiSelect-select': {
                                        //  color: 'red', // Text color of the selected item
                                        //  backgroundColor: '#00ff00', // Background color of the selected item
                                        //    },
                                        //  '& .MuiOutlinedInput-notchedOutline': {
                                        //    borderColor: 'green', // Border color of the select box
                                        //  },
                                        //   '& .MuiSelect-icon': {
                                        //     color: 'blue', // Color of the dropdown arrow
                                        //   },

                                    }}
                                    /*renderValue={(selected) => (selected ? selected : <span style={{ color: '#2e2e2e' }}>{UIString[lang]['ADMIN_PROFILE_DESC']}</span>)}*/
                                    onChange={(t) => { setNoticeChannel(t.target.value) }}
                                    value={noticeChannel}
                                    MenuProps={{
                                        sx: {

                                            '& .MuiPaper-root': {
                                                width: '200px',
                                                marginTop: '8px', // Moves the dropdown menu down by 10px
                                                marginRight: '-28px',
                                            },
                                        },
                                    }}
                                >
                                    {noticeForm.channels.map((item, map) => <MenuItem value={item.value} sx={{ fontSize: '13px', height: '22px', marginTop: '8px' }} >{item.label}</MenuItem>)}
                                </Select>
                            </td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Title</td>
                            <td className='detail_data_td' style={{ height: '48px' }}><TextField
                                variant='outlined'
                                value={title}
                                onChange={(t) => { if (t.target.value.length >= 200) { setTitle(String(t.target.value).substr(0, 200)); } else { setTitle(t.target.value); } }}
                                sx={{
                                    width: '100%',
                                    //height:'28px',
                                    '& .MuiOutlinedInput-root': {
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#a0a0a0', // Change the border color when focused
                                            borderWidth: '0px',
                                            borderCollapse: 'collapse',
                                            // backgroundColor:'#f2f2f2',
                                            //height:'28px',

                                        },
                                    },

                                    '& .MuiOutlinedInput-notchedOutline': {
                                        border: 'none', // Removes the border
                                        // backgroundColor:'#f2f2f2',
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            border: 'none', // Removes the border on hover
                                            //backgroundColor:'#f2f2f2',
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            border: 'none', // Removes the border on focus
                                            //backgroundColor:'#f2f2f2',
                                        },
                                    }
                                }}

                                InputProps={{
                                    style: { fontSize: '13px', color: '#222222', backgroundColor: '#f8f8f8', height: '38px', }, // Change input font size
                                }}
                            /></td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Content</td>
                            <td className='detail_data_td'>
                                <TextField
                                    variant='outlined'
                                    multiline
                                    rows={30}
                                    value={content}
                                    onChange={(t) => { if (t.target.value.length >= 4000) { setContent(String(t.target.value).substr(0, 4000)); } else { setContent(t.target.value); } }}
                                    sx={{
                                        width: '100%',
                                        '& .MuiOutlinedInput-root': {
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#a0a0a0', // Change the border color when focused
                                                borderWidth: '0px',
                                                borderCollapse: 'collapse',
                                                // backgroundColor:'#f2f2f2',

                                            },
                                        },

                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: 'none', // Removes the border
                                            // backgroundColor:'#f2f2f2',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                border: 'none', // Removes the border on hover
                                                //backgroundColor:'#f2f2f2',
                                            },
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                border: 'none', // Removes the border on focus
                                                //backgroundColor:'#f2f2f2',
                                            },
                                        }
                                    }}

                                    InputProps={{
                                        style: { fontSize: '13px', color: '#222222', backgroundColor: '#f8f8f8' }, // Change input font size
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className='detail_label_td' style={{ height: '48px' }}>Image</td>
                            <td className='detail_data_td'><input type='file' name='file' style={{ width: '300px' }} onChange={set_notice_file} /></td>
                        </tr>
                        <tr>
                            <td className='detail_label_td' colSpan={2} style={{ height: '100px' }}>&nbsp;&nbsp;</td>
                        </tr>
                        <tr>
                            <td className='detail_data_td' colSpan={2} style={{ textAlign: 'right' }}><Button size='small' sx={{ color: '#222222', backgroundColor: '#f2f2f2', fontWeight: 'normal', paddingRight: '18px', paddingLeft: '18px' }} onClick={() => { submit_form() }}>{UIString[lang]['SUBMIT']}</Button></td>
                        </tr>
                        {/*<tr>
                            <td className='detail_label_td' colSpan={2}><Divider sx={{ paddingLeft: '0px', '&::before': { width: 0 }, }} textAlign="left" /></td>
                        </tr>
                       
                        <tr>
                            <td className='detail_label_td'>Admin Status</td>
                            <td className='detail_data_td'>{detail.admin_status}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td' colSpan={2}><Divider sx={{ paddingLeft: '0px', '&::before': { width: 0 }, }} textAlign="left" /></td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Corp Users</td>
                            <td className='detail_data_td' >
                            <table style={{ width: '100%', height: '30px', borderWidth: '0px', border: 'none', borderCollapse: 'collapse' }}>
                                <tr>
                                    <td>{detail.corp_users}</td>
                                    <td style={{width:'180px',textAlign:'right'}}> <SectionNavButton label={UIString[lang]['LIST']} url={Util.page_url(lang,'/')}  /></td>
                                </tr>
                                </table>
                            </td>
                        </tr>*/}


                        <tr>
                            <td className='detail_label_td' style={{ height: '180px' }}>&nbsp;&nbsp;</td>
                            <td style={{ textAlign: 'left', padding: '0px' }} >
                                <table style={{ width: '100%', height: '180px', borderWidth: '0px', border: 'none', borderCollapse: 'collapse' }}>
                                    <tr>
                                        <td>&nbsp;&nbsp;</td>
                                        <td style={{ textAlign: 'right' }}>
                                            {detail.status == 'ACTIVE' ? <Chip label="INACTIVATE" color="#ffcc00" sx={{ width: '100px', fontSize: '11px', backgroundColor: '#f0f0f0', color: '#111111', marginRight: '-3px', cursor: 'pointer' }} onClick={() => { inactivate(detail.id) }} /> : <></>}
                                            {detail.status == 'INACTIVE' ? <Chip label="ACTIVATE" color="#ffcc00" sx={{ width: '100px', fontSize: '11px', backgroundColor: '#c2ff00', color: '#222222', cursor: 'pointer' }} onClick={() => { activate(detail.id) }} /> : <></>}
                                        </td>
                                        {/*<td style={{ textAlign: 'right' }}>
                                            { detail.status != 'DELETED' ? <><Chip label="SIGNOUT" color="#ffcc00" sx={{ width: '100px', fontSize: '11px', backgroundColor: '#a0a0a0', color: '#ffffff', marginRight: '-3px', cursor: 'pointer' }} onClick={() => { signout(detail.id) }} />&nbsp;&nbsp;&nbsp;&nbsp;
                                            <Chip label="DELETE" color="#ffcc00" sx={{ width: '100px', fontSize: '11px', backgroundColor: '#555555', color: '#ffffff', marginRight: '-3px', cursor: 'pointer' }} onClick={() => { delete_corp(detail.id) }} /></> : <></> }
                                        </td>*/}
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>

                    <br />

                </Paper>

                {flagContent == 'none' ? <Box sx={{ width: '100%', height: '600px', textAlign: 'center', fontSize: '13px' }}>
                    <WarningIcon style={{ fontSize: '80px', marginTop: '180px', marginBottom: '22px' }} /><br />
                    {UIString[lang]['NO_DATA']}
                </Box> : <></>}

                <div style={{ height: '600px' }}>&nbsp;&nbsp;</div>
                <Snackbar
                    sx={{}}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={flagToast}
                    onClose={closeToast}
                    autoHideDuration={1800}
                    key={'top' + 'center'}
                >
                    <SnackbarContent
                        sx={{
                            backgroundColor: '#fcfcfc',
                            color: '#222222',
                            minHeight: '60px',
                            fontSize: '13px',
                            display: "flex",
                            justifyContent: "space-between", // Space between text and icon
                            alignItems: "center",
                        }}

                        message={<Box display="flex" alignItems="center">
                            {toastModeIcon}&nbsp;&nbsp;
                            <span>{toastMsg}</span>
                        </Box>}
                        action={
                            <IconButton
                                size="small"
                                color="inherit"
                                onClick={() => console.log("Close clicked")}
                            >
                                <CloseIcon sx={{ cursor: 'pointer', fontSize: '18px', color: '#222222' }} onClick={() => { closeToast() }} />
                            </IconButton>}

                    />
                </Snackbar>

            </div>


            {lightbox && (
                <Lightbox

                    mainSrc={lightboxImages[0]}
                    //nextSrc={lightboxImages[(photoIndex + 1) % images.length]}
                    //prevSrc={lightboxImages[(photoIndex + images.length - 1) % images.length]}
                    onCloseRequest={() => { setLightbox(false) }}
                /*onMovePrevRequest={() =>
                    this.setState({
                        photoIndex: (photoIndex + images.length - 1) % images.length,
                    })
                }
                onMoveNextRequest={() =>
                    this.setState({
                        photoIndex: (photoIndex + 1) % images.length,
                    })
                }*/
                />
            )}

            <style>
                {`
          .ReactModal__Overlay.ReactModal__Overlay--after-open {
            z-index: 1201 !important; /* Set above MUI AppBar */
          }
          .custom-lightbox .ril__outer {
            z-index: 1201 !important; /* Ensure lightbox container is above */
          }
        `}
            </style>







        </>
    );

}